import { addAwareCartItem } from './aware-cart-api.js';

class AwareCompleteLookCards extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();

    this.addEventListener('change', this.handleChange, {
      signal: this.abortController.signal,
    });

    this.addEventListener('submit', this.handleSubmit, {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  handleChange = (event) => {
    const select = event.target.closest('[data-aware-complete-variant]');
    if (!select || !this.contains(select)) return;

    const card = select.closest('[data-aware-complete-card]');
    const option = select.options[select.selectedIndex];
    if (!card || !option) return;

    const price = card.querySelector('[data-aware-complete-price]');
    const image = card.querySelector('.aware-complete-look__image');

    if (price && option.dataset.price) {
      price.textContent = option.dataset.price;
    }

    if (image && option.dataset.imageUrl) {
      image.src = option.dataset.imageUrl;
      image.removeAttribute('srcset');
    }
  };

  handleSubmit = async (event) => {
    const form = event.target.closest('[data-aware-complete-form]');
    if (!form || !this.contains(form)) return;

    event.preventDefault();

    const button = form.querySelector('[data-aware-complete-add]');
    const status = this.querySelector('[data-aware-complete-status]');
    const formData = new FormData(form);
    const variantId = formData.get('id');

    if (!button || !variantId || button.disabled) return;

    const originalText = button.textContent.trim();
    button.disabled = true;
    button.textContent = 'Adding…';

    if (status) status.textContent = '';

    try {
      const result = await addAwareCartItem(variantId, 'aware-complete-the-look');

      button.textContent = 'Added';
      if (status) status.textContent = result.refreshWarning
        ? 'Item added. Open your cart to check the latest total.'
        : 'Item added to cart.';

      if (this.dataset.autoOpenCart === 'true') {
        await customElements.whenDefined('theme-drawer');
        document.querySelector('theme-drawer#cart-drawer')?.open?.();
      }

      window.setTimeout(() => {
        if (!document.body.contains(button)) return;
        button.textContent = originalText;
        button.disabled = false;
      }, 1000);
    } catch (error) {
      console.error('[Aware complete the look]', error);

      button.textContent = 'Try again';
      button.disabled = false;

      if (status) {
        status.textContent = error?.message || 'Unable to add this item. Please try again.';
      }

      window.setTimeout(() => {
        if (!document.body.contains(button)) return;
        button.textContent = originalText;
      }, 1500);
    }
  };
}

if (!customElements.get('aware-complete-look-cards')) {
  customElements.define('aware-complete-look-cards', AwareCompleteLookCards);
}
